import { render, staticRenderFns } from "./WrestlingTeamStandings.vue?vue&type=template&id=627752aa&scoped=true"
import script from "./WrestlingTeamStandings.vue?vue&type=script&lang=js"
export * from "./WrestlingTeamStandings.vue?vue&type=script&lang=js"
import style0 from "./WrestlingTeamStandings.vue?vue&type=style&index=0&id=627752aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627752aa",
  null
  
)

export default component.exports